import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	attachedFormLabel: {
		id: 'project-settings-product-features-jsm-common.form-panel.attached-form-label',
		defaultMessage: 'Attached form',
		description: 'Label for the section that shows the associated proforma form',
	},
	formSecurityWithIssueSecurityWarningDescription: {
		id: 'project-settings-product-features-jsm-common.form-panel.form-security-with-issue-security-warning-description',
		defaultMessage:
			'Restrictions on this form conflict with the issue security level set on this request type. Only those with access to both will be able to view this form.',
		description:
			'Description to display when the associated proforma form is restricted and issue-security is active on the request-type',
	},
	formSecurityWithIssueSecurityWarningDescriptionIssueTermRefresh: {
		id: 'project-settings-product-features-jsm-common.form-panel.form-security-with-issue-security-warning-description-issue-term-refresh',
		defaultMessage:
			'Restrictions on this form conflict with the work item security level set on this request type. Only those with access to both will be able to view this form.',
		description:
			'Description to display when the associated proforma form is restricted and work item security is active on the request-type',
	},
	formSecurityWithIssueSecurityWarningLabel: {
		id: 'project-settings-product-features-jsm-common.form-panel.form-security-with-issue-security-warning-label',
		defaultMessage: 'Select to view form security with issue security warning message',
		description:
			'The label for the warning icon that is shown when the associated proforma form is restricted and issue-security is active on the request-type',
	},
	formSecurityWithIssueSecurityWarningLabelIssueTermRefresh: {
		id: 'project-settings-product-features-jsm-common.form-panel.form-security-with-issue-security-warning-label-issue-term-refresh',
		defaultMessage: 'Select to view form security with work item security warning message',
		description:
			'The label for the warning icon that is shown when the associated proforma form is restricted and work item security is active on the request-type',
	},
	formSecurityAndIssueSecurityWarningLabel: {
		id: 'project-settings-product-features-jsm-common.form-panel.form-security-and-issue-security-warning-label',
		defaultMessage: 'View attached form warning message',
		description:
			'The label for the warning icon that is shown when the associated proforma form is restricted and issue-security is active on the request-type',
	},
});
